import { render, staticRenderFns } from "./VolunteersRegistrationComponent.vue?vue&type=template&id=25b70e70&"
import script from "./VolunteersRegistrationComponent.vue?vue&type=script&lang=js&"
export * from "./VolunteersRegistrationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports